import { restApi } from "@/api";

export const fetchBunchOfProfiles = (oldIds = []) => {
  return restApi.get("/users/explore", {
    params: { old_id: oldIds },
  });
};

export const fetchWhoLikedMeFeed = (page) => {
  return restApi.get("/likes/feed", { params: { page: page } });
};

/**
 * Fetches profiles of users who are currently online
 * @param {number} page - The page number for pagination
 * @returns {Promise} Promise representing the API response with online users data
 */
export const onlineProfiles = (page) => {
  return restApi.get("users/online", { params: { page } });
};

/**
 * Fetches profiles of users from pulse
 * @param {Object} params - Request parameters
 * @param {number} params.limit - The number of records to return
 * @param {string} [params.cursor] - Cursor for pagination
 * @param {number} [params.seed] - Session seed for consistent ordering
 * @param {string} [params.olderThan] - Legacy timestamp parameter
 * @returns {Promise} Promise representing the API response with feed users data
 */
export const fetchPulse = (params) => {
  return restApi.get("users/pulse", { params });
};

/**
 * Check if there are newer pulse entries
 * @param {Object} params - Request parameters
 * @param {string} params.newerThan - The timestamp to use to check after
 * @param {string} [params.feed_session_start_time] - Session start time for new entries check
 * @returns {Promise} Promise representing the API response
 */
export const fetchPulseNew = (params) => {
  return restApi.get("users/pulse-new", { params });
};
